import { useElementMotionStore } from "@/lib/stores/element-motion-store/element-motion-store";
import { useCurrentScale } from "remotion";
import { useShallow } from "zustand/react/shallow";

export default function SelectionMarquee() {
  const scale = useCurrentScale() || 1;

  const boundingBox = useElementMotionStore(
    useShallow((state) => state.marqueeBoundingBox),
  );

  if (!boundingBox) {
    return null;
  }

  const { left, top, right, bottom } = boundingBox;

  return (
    <div
      className="bg-blue-400/30"
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        transform: `translate3d(${left}px, ${top}px, 0)`,
        width: Math.max(right - left, 0),
        height: Math.max(bottom - top, 0),
        backgroundColor: "",
        outline: `${Math.ceil(1 / scale)}px solid var(--color-blue-400)`,
        willChange: "transform, width, height",
      }}
    ></div>
  );
}
